import { Alert, Box, Typography } from "@mui/material";
import { ShieldAlert } from "lucide-react";
import Button from "./Button";

const ImpersonationBanner = () => {
  const adminToken = localStorage.getItem("adminToken");

  if (!adminToken) return null;

  const handleReturnToAdmin = () => {
    localStorage.setItem("accessToken", adminToken);
    localStorage.removeItem("adminToken");
    window.location.href = "/admin";
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <Alert
        severity="warning"
        icon={<ShieldAlert size={20} />}
        sx={{
          borderRadius: 0,
          py: 0.5,
          display: "flex",
          alignItems: "center",
        }}
        action={
          <Button
            size="small"
            variant="contained"
            color="warning"
            onClick={handleReturnToAdmin}
            sx={{ fontWeight: 600 }}
          >
            Return to Admin
          </Button>
        }
      >
        <Typography variant="bodySm" fontWeight="medium">
          You are viewing as another user.
        </Typography>
      </Alert>
    </Box>
  );
};

export default ImpersonationBanner;
